import { FC } from 'react';

import { Button } from 'components/parts/Button';

import { useResetButton } from './useResetButton';

/**
 * ユーザーデータをリセットするボタンのコンポーネント
 */
export const ResetButton = () => {
  const { handleReset, isUpdating } = useResetButton();
  return <ResetButtonView handleReset={handleReset} isUpdating={isUpdating} />;
};
type ResetButtonViewProps = {
  handleReset: () => void;
  isUpdating: boolean;
};

/**
 * @typedef {object} ResetButtonViewProps
 * @property {function} handleReset - データをリセットする関数
 * @property {boolean} isUpdating - データ更新中かどうかの状態
 */

/**
 * リセットボタンのビジュアル部分を描画するコンポーネント
 * @param {ResetButtonViewProps} props
 * @returns JSX.Element
 */
export const ResetButtonView: FC<ResetButtonViewProps> = ({ handleReset, isUpdating }) => {
  return (
    <Button text="データ消去" styleType="primary" handleClick={handleReset} disabled={isUpdating} />
  );
};
